<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th :colspan="3" class="grey lighten-2 font-weight-bold subtitle-1">
            <div class="row">
              <span>学習目標</span>
              <v-spacer />
              <div
                v-if="_.findIndex(editDetailSection.goal, ['edit', true]) != -1"
              >
                <v-btn small @click="handleCancel">{{ $t("CANCEL") }}</v-btn>
                <v-btn
                  small
                  class="mx-3 primary"
                  @click="handleUpdate"
                  :loading="loading"
                  >保存</v-btn
                >
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(goal, index) in editDetailSection.goal" :key="goal.key">
          <td class="width-2">
            <strong>{{ goal.text }}</strong>
          </td>
          <td
            style="cursor: text"
            @click="handleEdit(goal)"
            :key="`goal-${index}-${tbody_goal}`"
          >
            <span class="pre-wrap" v-if="!goal.edit">{{ goal.value }}</span>
            <v-textarea
              solo
              v-else
              v-model="goal.value"
              :auto-grow="true"
              hide-details
              class="my-2"
              rows="2"
            />
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
import { updateSection } from "@/api/Section.api";
export default {
  store: ["editDetailSection"],
  data() {
    return {
      tbody_goal: 0,
      loading: false,
    };
  },
  methods: {
    handleEdit(goal) {
      let checkEdit = this.editDetailSection.lead_sentence.find(
        (e) => e.edit == true
      );
      if (checkEdit) {
        this.editDetailSection.statusEdit = true;
      } else {
        goal.edit = true;
        this.editDetailSection.isEdit = "goal";
      }
    },
    handleCancel() {
      this.$emit("setDefault");
      this.editDetailSection.goal.forEach((e) => {
        e.edit = false;
      });
      this.editDetailSection.statusEdit = false;
      this.editDetailSection.isEdit = "";
    },
    async handleUpdate() {
      this.loading = true;
      let goal = {};
      this.editDetailSection.goal.forEach((e) => {
        goal[e.key] = e.value;
      });
      console.log("goal: ", goal);
      let params = {
        sub_key: this.$route.params.chapter,
        id: this.$route.params.section,
        goal,
      };
      this.loadingListSection = true;
      await updateSection(params)
        .then(async () => {
          this.editDetailSection.goal.forEach((e) => {
            e.edit = false;
          });
          this.editDetailSection.statusEdit = false;
          this.editDetailSection.isEdit = "";
        })
        .catch(() => {
          // this.loaddingEditLeadSentence = false;
        });
      this.loading = false;
    },
  },
};
</script>
<style  scoped>
::v-deep tr td {
  border: 1px solid #ccc;
  border-top: none;
}
::v-deep tr th {
  border: 1px solid #ccc;
  border-bottom: none;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff !important;
}
</style>